@if (loadingService.isLoading()) {
    <div class="no-freeze-spinner">
      <div id="no-freeze-spinner">
        <div>
          <i class="mdi mdi-tennis-ball"></i>
          <i class="mdi mdi-badminton"></i>
          <i class="mdi mdi-table-tennis"></i>
          <div></div>
        </div>
      </div>
    </div>
  }